//  @flow

import * as React from 'react';

import './style.css';

type ContentSliderProps = {
  children: React.Node
};

type ContentSliderState = {
  currentIndex: number,
  totalItem: number
};
class ContentSlider extends React.PureComponent<
  ContentSliderProps,
  ContentSliderState
> {
  interval: any;
  childrenList: Array<React.Node>;

  constructor(props: ContentSliderProps) {
    super(props);
    this.state = {
      currentIndex: 0,
      totalItem: 0
    };
    this.interval = () => { };
    this.childrenList = [];
  }

  componentDidMount() {
    this.cloneChildren();
    this.setState({ totalItem: React.Children.count(this.props.children) });
    this.interval = setInterval(this.moveNext, 3000);
  }

  cloneChildren = () => {
    this.childrenList = React.Children.map(this.props.children, item =>
      React.cloneElement(item, [item.props])
    );
  };
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  moveNext = () => {
    this.setState(prevState => ({
      currentIndex:
        prevState.currentIndex === prevState.totalItem - 1
          ? 0
          : prevState.currentIndex + 1
    }));
  };

  moveBack = () => {
    this.setState(prevState => ({
      currentIndex:
        prevState.currentIndex === 0
          ? prevState.totalItem - 1
          : prevState.currentIndex - 1
    }));
  };

  getMinHeight = () => {
    const { innerWidth, innerHeight } = window;
    const aspectRatio = innerWidth / innerHeight;

    if (innerWidth < 768 || aspectRatio >= 1) {
      return 'calc(100vh - var(--navbar-height))';
    } else {
      return '50vh';
    }
  };

  goToSelectedItem = (index) => {
    this.setState({
      currentIndex: index
    });
    
    clearInterval(this.interval);
    this.interval = setInterval(this.moveNext, 3000);
  }

  render = () => {
    return (
      <div
        style={{
          minHeight: this.getMinHeight()
        }}
        className="content-slider">
        {this.childrenList[this.state.currentIndex]}
        <div className="content-slider-indicatorBox">
          {React.Children.map(this.props.children, (item, index) => (
            <div
              className={
                this.state.currentIndex === index
                  ? 'content-slider-indicator-active'
                  : 'content-slider-indicator-inactive'
              }
              onClick={() => this.goToSelectedItem(index)}
            />
          ))}
        </div>
      </div>
    );
  };
}

export default ContentSlider;



// WEBPACK FOOTER //
// ./src/Components/ContentSlider/index.js